export default __webpack_public_path__ + "static/media/logo_name.3caac668.jpg";